import React, {useState} from 'react';
import styled from 'styled-components';
import {
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  Button,
  Dialog,
  DialogContent
} from '@material-ui/core';
import { ordenaPor } from './helpers';
import Estatisticas from './Estatisticas';


const FormControl_ = styled(FormControl)`
  && {
    min-width: 120px;
  }
`


const ToggleBtn = styled.button`
  height: 22px;
  background: ${({ value, activeValue}) => (value == activeValue) ? `gray` : `white`};
  color: #424d63;
  border: 1px solid rgba(66, 77, 99, 0.5);
  border-radius: 4px;
  outline: 0;
  cursor: pointer;
`


const SearchField = styled.div`
  display: inline-flex;
  flex: 1 1 100px;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  & .fas {
    padding: 0.5rem;
  }
  & input {
    border: 0;
    padding: 0.5rem 0.5rem 0.5rem 0;
    flex: 1;
    outline: none;
  }
`


const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(0deg, #EEE, transparent);
  margin: 0px -10px 5px -10px;
  padding: 0px 0px 5px 10px;
  & > * {
    margin-right: 20px;
  }
  /* & span {
    border-left: 1px solid black;
  } */
  /* & span:first-child {
    border: none;
  } */
`


export default function FuncionariosHeader(props) {
  const {
    funcionarios,
    dptos,
    qtde,
    dptoSel,        setDptoSel,
    funcFilter,     setFuncFilter,
    campoOrdenar,   setCampoOrdenar,
    ordenaAscDesc,  setOrdenaAscDesc
  } = props;
  let [ qtdeTotal, qtdeFiltrada ] = qtde;

  const [ modal, setModal ] = useState(false);
  const m = {
    isOpen: Boolean(modal),
    open: (id_) => () => setModal(id_),
    close: () => setModal(false)
  }

  return (
    <>
    <HeaderContainer>
      <div>
        <Seletor
          label="Departamento"
          valor={dptoSel}
          alterar={setDptoSel}
          opts={dptos}
          mostraVazio={true}
          textoVazio="Todos"
        />
      </div>
      <div>
        <Seletor
          label="Ordenar Por"
          valor={campoOrdenar}
          alterar={setCampoOrdenar}
          opts={ordenaPor}
        />
        <span style={{display: 'inline-flex', flexDirection: 'column', margin: '3px 0px 0px 3px'}}>
          <div>
            <ToggleBtn
              title='crescente'
              value='asc'
              activeValue={ordenaAscDesc}
              onClick={() => setOrdenaAscDesc('asc')}
            >
              ▲
            </ToggleBtn>
          </div>
          <div>
            <ToggleBtn
              title='decrescente'
              value='desc'
              activeValue={ordenaAscDesc}
              onClick={() => setOrdenaAscDesc('desc')}
            >
              ▼
            </ToggleBtn>
          </div>
        </span>
      </div>
      <div>
        <SearchField>
          <i className={`fas fa-search`}></i>
          <input type="text" name="" id=""
            onChange={e => setFuncFilter(e.target.value)}
            value={funcFilter}
          />
        </SearchField>
      </div>
      <div>
        {`${qtdeFiltrada} / ${qtdeTotal}`}
      </div>
      <div>
        <Button 
          variant="outlined"
          color="primary"
          onClick={m.open(true)}
        >
          Estatísticas
        </Button>
      </div>
    </HeaderContainer>
    <Dialog
      maxWidth='md'
      open={m.isOpen}
      onClose={m.close}
      scroll="body"
    >
      <DialogContent>
        <Estatisticas
          funcionarios={funcionarios}
        />
      </DialogContent>
    </Dialog>    
    </>
  )
}


function Seletor (props) {
  let { label, valor, alterar, opts, mostraVazio=false, textoVazio="" } = props 
  const handleChange = e => { alterar(e.target.value); }
  return (
    <FormControl_>
      <InputLabel shrink>
        {label}
      </InputLabel>
      <Select
        value={valor}
        onChange={handleChange}
        displayEmpty={mostraVazio}
      >
        { mostraVazio && (
          <MenuItem value="">
            <em>{textoVazio}</em>
          </MenuItem>
        )}
        {opts.map(dpto => {
          return (
            <MenuItem value={dpto.Codigo}>{dpto.Nome}</MenuItem>
          )
        })}
      </Select>
      {/* <FormHelperText>Label + placeholder</FormHelperText> */}
    </FormControl_>
  )
}
